import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type Flow from 'garaje/models/flow';
import type Location from 'garaje/models/location';
import type StateService from 'garaje/services/state';

export interface VisitorsQuestionnairesRouteModel {
  fetchFlowsPage: (page: number, searchTerm: string) => Promise<Flow[]>;
  flows: Flow[];
  location: Location;
}

export default class VisitorsQuestionnairesRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare store: Store;

  redirect(): void {
    if (this.abilities.cannot('navigate to questionnaires')) {
      void this.router.replaceWith('unauthorized');
    }
  }

  async model(): Promise<VisitorsQuestionnairesRouteModel> {
    const location = this.state.currentLocation;
    const flows = await this.store.query('flow', {
      filter: { location: location.id, property_owned: false },
    });
    return {
      flows: flows.slice(),
      fetchFlowsPage: (page: number, searchTerm: string) => Promise.resolve(this.fetchFlowsPage(page, searchTerm)),
      location,
    };
  }

  fetchFlowsPage(_page: number, searchTerm: string): Flow[] {
    let { flows } = <VisitorsQuestionnairesRouteModel>this.modelFor(this.routeName);
    flows = flows.filter((flow) => !flow.isGlobalChild);
    if (!isEmpty(searchTerm)) {
      flows = flows.filter((flow) => flow.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    return flows.toSorted((a, b) => a.name.localeCompare(b.name));
  }
}
